module.exports = {
  defaultTitle: "Food Blog",
  description: "料理レシピを紹介するブログ",
  openGraph: {
    type: "website",
    locale: "ja_JP",
    url: "https://food-blog-chi.vercel.app/",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    site_name: "Food Blog",
    images: [
      {
        url: "https://food-blog-chi.vercel.app/images/site-logo-512x512.png",
      },
    ],
  },
  twitter: {
    handle: "@pandashark6",
    cardType: "summary",
  },
};
